import React from 'react';
import { X, Phone, Calendar } from 'lucide-react';
import Cal from "@calcom/embed-react";
import { useDentoData } from '../context/DentoContext';

export const AppointmentModal = ({ isOpen, onClose }) => {
    const { hospitalData } = useDentoData();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300"
                onClick={onClose}
            ></div>

            <div className="bg-white rounded-[24px] md:rounded-[32px] w-full max-w-5xl h-[95vh] md:h-[85vh] shadow-[0_32px_128px_rgba(0,0,0,0.2)] relative overflow-hidden animate-in fade-in zoom-in-95 duration-500 border border-gray-100 flex flex-col mx-2 sm:mx-0">
                {/* Header */}
                <div className="flex items-center justify-between p-4 md:p-6 border-b border-gray-50 bg-white">
                    <div className="flex items-center gap-3">
                        <div className="bg-black p-2 md:p-2.5 rounded-xl md:rounded-2xl text-white shadow-lg">
                            <Calendar className="w-5 h-5 md:w-6 md:h-6" />
                        </div>
                        <div>
                            <h3 className="text-lg md:text-xl font-bold text-black uppercase tracking-widest">Book Your Visit</h3>
                            <p className="text-[10px] md:text-xs text-gray-400 font-medium whitespace-nowrap">Automatic confirmation & reminders</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 md:p-3 bg-gray-50 rounded-xl md:rounded-2xl hover:bg-black hover:text-white transition-all duration-300 group"
                    >
                        <X className="w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:rotate-90" />
                    </button>
                </div>

                {/* Calendar View */}
                <div className="flex-1 overflow-y-auto bg-white p-2">
                    <Cal
                        calLink={hospitalData?.calLink || "ajinkya-patil/15min"}
                        style={{ width: "100%", height: "100%", minHeight: "500px" }}
                        config={{
                            layout: 'month_view',
                            theme: 'light',
                            timeFormat: 12
                        }}
                    />
                </div>

                {/* Footer Info */}
                <div className="p-4 border-t border-gray-50 bg-white flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-4 md:gap-6">
                        <div className="flex items-center gap-2">
                            <Phone className="w-4 h-4 text-black" />
                            <span className="text-xs md:text-sm font-bold text-black uppercase tracking-wider font-heading">+91-99 223 223 11</span>
                        </div>
                    </div>
                    <p className="text-[8px] md:text-[10px] text-gray-300 uppercase font-black tracking-[0.2em]">Designed for Dr. Ajinkya Patil</p>
                </div>
            </div>
        </div>
    );
};
